module.exports = __webpack_public_path__ + "static/media/anchorage.2fa397aa.svg";